import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { swalConfirm, swalToast } from "../../utils/swal";

export default function UserDropdown({ nombreUsuario, onLogout }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen(!open);

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const inicial = (nombreUsuario || "U").trim().charAt(0).toUpperCase();

  return (
    <div ref={dropdownRef} className="relative inline-block text-left">
      {/* Botón principal */}
      <button
        onClick={toggleDropdown}
        className="
          flex items-center gap-2.5 pl-1.5 pr-3 py-1.5 rounded-xl text-white
          glass-panel hover:bg-white/15 transition-all duration-200
          focus:outline-none min-w-[44px] md:min-w-[160px]
        "
      >
        {/* Avatar inicial gradiente */}
        <span className="w-8 h-8 rounded-full flex items-center justify-center bg-gradient-to-br from-spark-400 to-sirius-600 ring-2 ring-white/20 text-white font-display font-bold text-sm">
          {inicial}
        </span>

        {/* Nombre usuario */}
        <span className="hidden md:flex flex-col items-start min-w-0">
          <span className="text-sm font-semibold leading-none truncate max-w-[110px]">
            {nombreUsuario || "Usuario"}
          </span>
          <span className="text-[0.6rem] uppercase tracking-wider text-white/45 mt-0.5">
            Sesión activa
          </span>
        </span>

        {/* Flecha */}
        <i className={`fas fa-chevron-down ml-auto text-xs transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 mt-2 w-60 rounded-2xl shadow-sirius-lg bg-white ring-1 ring-slate-200/70 z-50 overflow-hidden animate-sirius-fade-up">
          {/* Header */}
          <div className="flex items-center gap-3 px-4 py-3.5 bg-gradient-to-br from-sirius-50 to-spark-500/5 border-b border-slate-100">
            <span className="w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-spark-400 to-sirius-600 text-white font-display font-bold">
              {inicial}
            </span>
            <div className="min-w-0">
              <p className="text-ink-900 text-sm font-semibold truncate">{nombreUsuario || "Usuario"}</p>
              <p className="text-ink-500 text-[0.7rem] uppercase tracking-wider">Quantus Invoice</p>
            </div>
          </div>

          <div className="py-1.5">
            <Link
              to="/profile"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-4 py-2.5 text-sm font-medium text-ink-700 hover:bg-sirius-50 hover:text-sirius-700 transition-colors"
            >
              <i className="fas fa-user w-4 text-center" /> Mi perfil
            </Link>
            <div className="my-1 h-px bg-slate-100" />
            <button
              onClick={async () => {
                setOpen(false);
                // (2026-05-17) Confirmación SweetAlert2 antes del cierre de
                // sesión iniciado por el usuario. El auto-logout por
                // expiración (handleLogout(true)) NO pasa por aquí, así que
                // sigue siendo inmediato y sin diálogo.
                const ok = await swalConfirm(
                  "¿Cerrar sesión?",
                  "Se cerrará tu sesión actual en Quantus Invoice.",
                  { confirmText: "Sí, cerrar sesión", cancelText: "Cancelar", danger: true }
                );
                if (ok) {
                  swalToast("Sesión cerrada", "success");
                  onLogout();
                }
              }}
              className="flex items-center gap-3 w-full text-left px-4 py-2.5 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors"
            >
              <i className="fas fa-right-from-bracket w-4 text-center" /> Cerrar sesión
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
